import axios from 'axios';
import UserAuthKey from '../../components/Common/UserAuthKey';
export const WISHLIST_EXPORT_URL = process.env.REACT_APP_SMILES_SERVICE_REST_ENDPOINT + '/dh-customer/wishlist-items-export';
export const WISHLIST_API_URL = process.env.REACT_APP_SMILES_SERVICE_REST_ENDPOINT + '/dh-customer/wishlist-items';
export const WISHLIST_API_TOKEN = process.env.REACT_APP_OMS_API_KEY;
export const UPDATE_WISHLIST_CSSTATUS_URL = process.env.REACT_APP_SMILES_SERVICE_REST_ENDPOINT + '/dh-customer/update-wishlist-csstatus';
export const CS_ACTIVITY_LOG_URL = process.env.REACT_APP_OMS_API + 'v1/cs-activity-log/add';
export const CS_ACTIVITY_LOG_LIST_URL = process.env.REACT_APP_OMS_API + 'v1/cs-activity-log/list';

export const fetchWishlistItems = async ({ country = 'ae', limit = 10, start = 0, customerId, sku, search, status, ...advancedFilter }) => {
  const payload = { country, limit, start };
  if (customerId) payload.customerId = customerId;
  if (sku) payload.sku = sku;
  if (search) payload.search = search;
  if (status) payload.status = status;
  if (advancedFilter && Object.keys(advancedFilter).length > 0) {
    Object.assign(payload, advancedFilter);
  }
  try {
    const response = await axios.post(WISHLIST_API_URL, payload, {
      headers: {
        'authorization': `Bearer ${WISHLIST_API_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    if (response.status === 200) {
      // The API returns { data: [...], message: "..." }
      return response.data.data || [];
    } else {
      throw new Error('Failed to fetch wishlist items');
    }
  } catch (error) {
    throw error;
  }
};

export const addCsActivityLog = async ({ user_id, user_name, event_id, type, comment }) => {
  // Use Bearer token if available
  const bearerToken = typeof UserAuthKey === 'function' ? UserAuthKey() : null;
  const config = {
    method: 'POST',
    url: CS_ACTIVITY_LOG_URL,
    headers: {
      ...(bearerToken ? { Authorization: `Bearer ${bearerToken}` } : {}),
      'Content-Type': 'application/json',
    },
    data: {
      user_id,
      user_name,
      event_id,
      type,
      comment,
    },
    // Do NOT use withCredentials to avoid CORS error
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error, 'error');
    throw error;
  }
};

export const updateWishlistCsStatus = async ({ wishlistId, wishlistItemId, isCsContacted, comments, user_id, user_name, convertStatus, csUpdatedAt, csAgent }) => {
  const payload = { wishlistId, wishlistItemId, isCsContacted, convertStatus, csUpdatedAt, csAgent };
  if (comments) payload.comments = comments;
  try {
    const response = await axios.post(UPDATE_WISHLIST_CSSTATUS_URL, payload, {
      headers: {
        'authorization': `Bearer ${WISHLIST_API_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    // On success, call activity log API
    await addCsActivityLog({
      user_id: user_id || 456, // fallback to dummy user
      user_name: user_name || '',
      event_id: wishlistItemId,
      type: 'wishlist',
      comment: comments || '',
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchWishlistCommentLog = async ({ event_id }) => {
  const res = await axios.get(CS_ACTIVITY_LOG_LIST_URL, {
    params: {
      event_id,
      type: 'wishlist'
    },
    headers: {
      'Content-Type': 'application/json'
    }
    // withCredentials: true // Uncomment if cookies/session required
  });
  return res.data; // Return the full response so you get all records
};

export const exportWishlistItems = async ({ country, status, frmDt, toDt }) => {
  const payload = {
    country,
    status,
    frmDt,
    toDt
  };
  try {
    const response = await axios.post(WISHLIST_EXPORT_URL, payload, {
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${WISHLIST_API_TOKEN}`
      },
      responseType: 'blob'
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
